import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import CircularProgress from '@material-ui/core/CircularProgress';
import Label from 'globalcomponents/UI/FormLabel/Clutch';
import Message from 'globalcomponents/UI/Message/Clutch';
import Button from 'globalcomponents/UI/Button/Clutch';
import SubHeader from 'globalcomponents/SubHeader/Clutch';
import { getMediaPath, mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window.$environment?.CURRENT_LAYOUT;
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;
const RenderComponent = ({ values, handleEdit, errors, isNotValid, validateForm, customProps, submitAction }) => {
  const { i18n } = useTranslation();
  const { Styled, hasApiStatus } = customProps;
  const NewUI = window.$environment.SERVICE_PROVIDER === 'webfleet';
  return (
    <>
      <Styled.LoginHeader>
        <img alt="logo" src={getMediaPath(mediaUrls.clutchLogo, true)} className="ClutchLogo" />
        {!NewUI && (
          <>
            <SubHeader variant="h2" text={i18n.t('Multi Factor Authentication')} mode="light" className="loginHeader" />
          </>
        )}
      </Styled.LoginHeader>
      <Styled.LoginContent newUI={NewUI}>
        {NewUI && (
          <>
            <SubHeader variant="h2" text={i18n.t('Multi Factor Authentication')} mode="dark" className="loginHeader" />
          </>
        )}
        {hasApiStatus?.errorMessage && (
          <Styled.LoginError>
            <Message type="error" message={i18n.t(hasApiStatus.errorMessage)} />
          </Styled.LoginError>
        )}
        <Styled.userNameWrapper>
          <FormStyle.FieldsWrapper width="100%">
            <Label variant="body1">{i18n.t('common.mfacode')}</Label>
            <FormStyle.TextWrapper>
              <Field
                name="mfacode"
                handleOnChange={(event) => {
                  if (event.length > 6) {
                    return;
                  }
                  handleEdit(event, { field: 'mfacode', type: 'mfacode' });
                }}
                type="number"
                size="6"
                as={Input}
                placeholder={i18n.t('MFA Code')}
                value={values.mfacode}
                mode="light"
              />
              {errors['mfacode'] && !isNotValid && <Message type="error" message={errors['mfacode']} />}
            </FormStyle.TextWrapper>
          </FormStyle.FieldsWrapper>
        </Styled.userNameWrapper>
        <Styled.LoginButtonWrapper newUI={NewUI}>
          <FormStyle.ButtonsWrapper>
            <Button
              type="submit"
              label={hasApiStatus?.isLoading ? <CircularProgress color="inherit" /> : i18n.t('common.authenticate')}
              onClick={() => {
                const validateResponse = validateForm();
                validateResponse.then((data) => submitAction(data));
              }}
              id="forgotPasswordButton"
            />
          </FormStyle.ButtonsWrapper>
        </Styled.LoginButtonWrapper>
      </Styled.LoginContent>
      {NewUI && <span className="patentText">{i18n.t('footer.copyright')}</span>}
    </>
  );
};

export default RenderComponent;

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  customProps: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired,
};
